import React from 'react';
import Checkbox from 'ui/Checkbox';

interface IItineraryVisibilityOptionsProps {
  isTripOverviewVisible: boolean;
  onTripOverviewVisibilityChange: (isVisible: boolean) => void;
}

export const ItineraryVisibilityOptions: React.FC<IItineraryVisibilityOptionsProps> = ({
  isTripOverviewVisible,
  onTripOverviewVisibilityChange,
}) => {
  return (
    <div className="mb-8">
      <div className="flex flex-row gap-6 mb-6">
        <label className="flex items-center gap-3 cursor-pointer">
          <Checkbox
            checked={isTripOverviewVisible}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              onTripOverviewVisibilityChange(e.target.checked);
            }}
          />
          <span className="text-base font-pt-sans">Show Trip Overview</span>
        </label>
      </div>
    </div>
  );
};
